import { api, resolvePagination } from './api';
import { getLastYearDate, getRequestDate } from 'utils/dateUtils';

const nextDay = () => {
    const currentDate = new Date();
    const nextDay = new Date(currentDate);
    nextDay.setDate(currentDate.getDate() + 1);
    return nextDay;
};

/**
 * Get a list of alerts.
 */
export const getAlerts = async ({
    patient,
    group,
    ack_pending,
    pageLimit,
    pageToken,
    qi = getLastYearDate(3),
    df = nextDay()
}) =>
    api.post(
        '/cheart/alerts',
        {
            qi: qi ? getRequestDate(qi) : undefined,
            qf: df ? getRequestDate(df) : undefined,
            patient,
            group,
            ack_pending
        },
        {
            headers: resolvePagination(pageToken, pageLimit)
        }
    );

/**
 * Mark Alert as read.
 * @param {string} uuid - The unique identifier of the alert.
 */
export const ackAlert = async (uuid) => {
    const response = await api.post('/cheart/alert/ack', { uuid });
    return response.data;
};
